import { render, staticRenderFns } from "./ProductImages2.vue?vue&type=template&id=183e340c&scoped=true&"
import script from "./ProductImages2.vue?vue&type=script&lang=js&"
export * from "./ProductImages2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183e340c",
  null
  
)

export default component.exports